import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthContext';
import { supabase } from '../supabaseClient';

const UserQuoteRequests = () => {
  const { user } = useAuth();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRequests = async () => {
      if (!user) return;
      setLoading(true);
      setError(null);
      const { data, error } = await supabase
        .from('quote_requests')
        .select('*')
        .eq('email', user.email)
        .order('created_at', { ascending: false });
      if (error) {
        setError('Failed to fetch your quote requests.');
        setRequests([]);
      } else {
        setRequests(data || []);
      }
      setLoading(false);
    };
    fetchRequests();
  }, [user]);

  if (!user) return <div className="text-center mt-10">You must be logged in to view your quote requests.</div>;
  if (loading) return <div className="text-center mt-10">Loading...</div>;

  return (
    <div className="max-w-2xl mx-auto mt-10 p-6 bg-white rounded-xl shadow-soft">
      <h2 className="text-2xl font-bold mb-4">My Quote Requests</h2>
      {error && <div className="text-red-500 mb-4">{error}</div>}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white rounded-xl shadow-soft">
          <thead>
            <tr>
              <th className="px-4 py-2">Status</th>
              <th className="px-4 py-2">Message</th>
              <th className="px-4 py-2">Created At</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((req) => (
              <tr key={req.id} className="border-t">
                <td className="px-4 py-2">{req.status}</td>
                <td className="px-4 py-2">{req.message}</td>
                <td className="px-4 py-2">{new Date(req.created_at).toLocaleString()}</td>
              </tr>
            ))}
            {requests.length === 0 && (
              <tr>
                <td colSpan={3} className="text-center py-4 text-gray-500">
                  You have not submitted any quote requests yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserQuoteRequests; 